import { FeatureList, FeaturesSettings, SiteFeature } from '../../models';
import { siteContext, siteSettingsHttp } from '../site-settings-api';

export const getSiteFeatures = async (locale: string): Promise<FeaturesSettings> => {
  const features = Object.values(SiteFeature).join(',');
  const url = `/feature/${siteContext}/${locale}?features=${features}`;
  const { data } = await siteSettingsHttp.get<FeatureList>(url);
  return data.reduce<FeaturesSettings>((settings, feature) => {
    return { ...settings, [feature.name]: feature.value };
  }, {});
};
